module.exports = {
  PARTIAL_LEATHER: 'partial-leather',
  UNKNOWN: 'unknown',
  FULL_LEATHER: 'full-leather',
  VELVET_TISSUES: 'velvet-tissues',
};
